var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewrequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 11.1C10.5 11.1 8.3 13.3 8.3 16.1C8.3 18.9 10.5 21.1 13.3 21.1C16.1 21.1 18.3 18.9 18.3 16.1C18.3 13.3 16 11.1 13.3 11.1ZM15.6 16.8H13.9V18.5C13.9 18.8 13.6 19.1 13.3 19.1C13.1 19.1 12.9 19 12.8 18.9C12.7 18.8 12.6 18.6 12.6 18.5V16.8H10.9C10.7 16.8 10.6 16.7 10.5 16.6C10.4 16.5 10.3 16.3 10.3 16.1C10.3 15.8 10.6 15.5 10.9 15.5H12.6V13.8C12.6 13.5 12.9 13.2 13.2 13.2C13.6 13.2 13.8 13.5 13.8 13.8V15.5H15.5C15.8 15.5 16.1 15.8 16.1 16.1C16.2 16.5 15.9 16.8 15.6 16.8ZM14 2H10.8C10.4 0.8 9.3 0 8 0C6.7 0 5.6 0.8 5.2 2H2C0.9 2 0 2.9 0 4V19C0 20.1 0.9 21 2 21H8.1C7.5 20.4 7 19.7 6.7 19H2V4H4V5C4 6.1 4.9 7 6 7H10C11.1 7 12 6.1 12 5V4H14V9.1C14.7 9.2 15.4 9.4 16 9.7V4C16 2.9 15.1 2 14 2ZM8 4C7.5 4 7 3.6 7 3C7 2.4 7.5 2 8 2C8.5 2 9 2.4 9 3C9 3.6 8.5 4 8 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewrequest);
export default __webpack_public_path__ + "static/media/Newrequest.67f47490a1c895d26b9dea5738566dfd.svg";
export { ForwardRef as ReactComponent };